// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3YJz8","tab":"ProcedureTabs_tab__3_V7Y"};